var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.55806 7.05806C4.80214 6.81398 5.19786 6.81398 5.44194 7.05806L8.55633 10.1724C8.89363 10.5097 9.12038 10.7358 9.30897 10.8959C9.49198 11.0513 9.59755 11.1075 9.67811 11.1337C9.88732 11.2016 10.1127 11.2016 10.3219 11.1337C10.4024 11.1075 10.508 11.0513 10.691 10.8959C10.8796 10.7358 11.1064 10.5097 11.4437 10.1724L14.5581 7.05806C14.8021 6.81398 15.1979 6.81398 15.4419 7.05806C15.686 7.30214 15.686 7.69786 15.4419 7.94194L12.3276 11.0563L12.3096 11.0743C11.9949 11.389 11.7322 11.6517 11.5 11.8488C11.2579 12.0544 11.0082 12.225 10.7082 12.3225C10.2479 12.472 9.7521 12.472 9.29184 12.3225C8.99184 12.225 8.74214 12.0544 8.5 11.8488C8.26783 11.6517 8.00512 11.389 7.69037 11.0743L7.67244 11.0563L4.55806 7.94194C4.31398 7.69786 4.31398 7.30214 4.55806 7.05806Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.345be065225ddbb107b877d06963bd17.svg";
export { ForwardRef as ReactComponent };